import React from 'react';
import { theme } from 'config/theme';
import { KeyboardArrowUpOutlined, KeyboardArrowDownOutlined } from '@mui/icons-material';
import DragHandleOutlined from '@mui/icons-material/DragHandleOutlined';

type TaskImpactIconProps = {
  impact: string;
  size?: number;
};

const IMPACT_ICON_COLORS = {
  low: theme.palette.custom.link,
  medium: theme.palette.custom.mangoTango,
  high: theme.palette.custom.redWine,
};

const TaskImpactIcon: React.FC<TaskImpactIconProps> = ({ impact, size = 20 }) => {
  switch (impact.toLowerCase()) {
    case 'high':
      return (
        <KeyboardArrowUpOutlined htmlColor={IMPACT_ICON_COLORS.high} sx={{ fontSize: size }} />
      );
    case 'low':
      return (
        <KeyboardArrowDownOutlined htmlColor={IMPACT_ICON_COLORS.low} sx={{ fontSize: size }} />
      );
    case 'medium':
    default:
      return <DragHandleOutlined htmlColor={IMPACT_ICON_COLORS.medium} sx={{ fontSize: size }} />;
  }
};

export default TaskImpactIcon;
